import { render, staticRenderFns } from "./NormalSearchNav457.vue?vue&type=template&id=fa0c20fc&scoped=true&"
import script from "./NormalSearchNav457.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav457.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0c20fc",
  null
  
)

export default component.exports